<script>
  import { digitalLoadMethods, digitalLoadComputed, layoutMethods,exportMethods,erpFixMessages, erpUserRolesMethods } from '@/state/helpers';
  import Swal from 'sweetalert2';
  import { required } from "vuelidate/lib/validators";
  import { getModuleAccess } from '@/router/helper.js'

  /**
   * Network component
   */
  export default {
    page: {
      title: "Network Group",
    },
    data() {
      return {
        title: "Network Group",
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
        filter: null,
        filterOn: [],
        sortBy: "value",
        sortDesc: false,
        submitted: false,
        fieldsNetwork: [
          {
            key: 'action',
            sortable: false
          },
          {
            key: 'name',
            sortable: true
          },
          {
            key: 'image',
            sortable: false
          },
          {
            key: 'status',
            sortable: true
          },
          {
            key: 'service',
            sortable: false
          },
          {
            key: 'description',
            sortable: false
          },
        ],
        name: "",
        id:0,
        deleteNetworkName: "",
        itemsNetwork: [],
        formExitChecker:"",
        searchValue: {
          searchField: null,
          search: "",
          sort: 'id',
          orderDesc: true,
          status : null,
          service: null
        },
        statusList: [
          { text: "All", value: null },
          { text: "Active", value: 'a' },
          { text: "Inactive", value: 'i' }
        ],
        searchListNetwork: [{ text: "Network Name", value: null }],
        eloadServiceOptions: [{ text: "All", value: null }],
        eloadNetworkGroupModule: {
          access: {
            create: true,
            delete: true
          }
        }
      };
    },
    validations:{
      name:{required}
    },
    computed: {
      ...digitalLoadComputed,
      ...erpFixMessages,
      rows() {
        return this.itemsNetwork.length
      }
    },
    async mounted() {
      this.getNetworkGroupList();
      this.changeTitle({title: 'Network Group'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'}},
          { text: 'Digital Load', to: { name: 'Digital Load'} },
          { text: 'Network Group', to: { name: 'Network Group'} }
        ]
      });
      this.actionNetworkGroup({
          action: "services",
          body: {}
      })
      .then((res) => {
        for(let c of res.rows){
          this.eloadServiceOptions.push({text:c["name"], value:c["id"]})
        }
      }).catch((e)=>{
        console.log("error while setup of parent category option",e);
      });

      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Products', 'eLoad', 'eLoad Networks')
      .then((access) => this.eloadNetworkGroupModule.access = access);

    },
    methods: {
      ...layoutMethods,
      ...digitalLoadMethods,
      ...exportMethods,
      ...erpUserRolesMethods,
      async getNetworkGroupList() {
        await this.getEloadNetworkGroupListAll({
          page: this.currentPage,
          rows: this.perPage,
          ...this.searchValue
        })
      },
      createNetwork() {
        this.submitted = true
        this.$v.$touch();

        if (!this.$v.name.$invalid){
          this.actionNetworkGroup({
            action: "create",
            body:{networkName: this.name}
          })
          .then(() => {
            this.$alertify.success("Added Successfully");
            this.name = ""
            this.$bvModal.hide('bv-modal-create-network')
            this.getNetworkGroupList()
          })
          .catch(function(error) {
            this.$alertify.error(error);
            console.log(error);
            this.name = ""
            this.$bvModal.hide('bv-modal-create-network')
          });
        }
      },
      updateEloadNetwork() {
        this.submitted = true
        this.$v.$touch();

        if (!this.$v.name.$invalid){
          this.actionNetworkGroup({
            action: "update",
            body:{
              networkName: this.name,
              id: this.id.toString()
            }
          })
          .then(() => {
            this.$alertify.success("Updated Successfully");
            this.name = ""
            this.id = 0
            this.$bvModal.hide('bv-modal-update-network')
            this.getNetworkGroupList()
            return;
          })
          .catch(function(error) {
            console.log(error);
            this.$alertify.error(error);
            this.name = ""
            this.id = 0
            this.$bvModal.hide('bv-modal-update-network')
            return;
          });
        }
      },
      async deleteEloadNetwork(id,name) {
        if (!this.eloadNetworkGroupModule.access.delete) {
          Swal.fire(
            "Access Restricted",
            "You are not allowed to delete a Network.",
            "warning"
          );
        } else {
          Swal.fire({
              title: "Are you sure?",
              text: `Do you really want to delete ${name}? This process cannot be undone.`,
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: "Yes",
              cancelButtonText: 'No'
          }).then((result) => {
            if(result.isConfirmed) {
              this.actionNetworkGroup({
                action: "delete",
                body: {
                  networkId: id
                }
              }).then(() => {
                Swal.fire("Delete Successful!", `Network ${name} has been deleted.`,"success");
                this.getNetworkGroupList();
              })
              .catch((error) =>{
                Swal.fire("Delete Failed!", `An Error Occured: ${error}`, "danger");
                console.log(error);
              });
            } else {
              return;
            }
          })
        }
      },
      leaveform(modal){
          if(JSON.stringify(this.name) == JSON.stringify(this.formExitChecker)){
              this.$bvModal.hide(modal)
              this.formExitChecker = ''
              return;
          }
          Swal.fire({
              title: 'Are you sure?',
              text: "you want to leave this page?",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '##804997',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No'
          }).then((result) => {
              if (result.isConfirmed) {
                  this.formExitChecker = ''
                  this.$bvModal.hide(modal)
              }else{
                  return;
              }
          })
      },
      onPageUpdate(reset = "") {
        if(reset == "reset"){
          this.currentPage = 1
        }
        this.getNetworkGroupList()
      },
      onSearch() {
        this.currentPage = 1
        if (this.searchValue.search) {
          this.searching = true
        } else {
          this.searching = false
        }
        this.getNetworkGroupList()
      },
      eloadNetworkSort(ctx){
        this.searchValue.sort = ctx.sortBy;
        this.searchValue.orderDesc = ctx.sortDesc;
        console.log(">> sorting",this.searchValue);
        if(this.prev_sort != ctx.sortBy){
          this.prev_sort = ctx.sortBy
          this.currentPage = 1
        }
        this.getNetworkGroupList();
      },
      onDisplayChange(){
        console.log(this.loadNetworkGroupAllTotalRows,this.perPage,this.loadNetworkGroupListAll.length,(this.loadNetworkGroupListAll.length < this.loadNetworkGroupAllTotalRows && this.loadNetworkGroupListAll.length != this.perPage));
        if(
          (this.loadNetworkGroupListAll.length < this.loadNetworkGroupAllTotalRows && this.loadNetworkGroupListAll.length != this.perPage) || // condition for incrementing display per page
          (this.loadNetworkGroupListAll.length == this.loadNetworkGroupAllTotalRows && this.perPage < this.loadNetworkGroupListAll.length) // condition for decreasing display per page
          ){
          this.onPageUpdate('reset')
        }
      },
      editNetwork(item){
        console.log(">> EDIT:", item);
        this.$router.push(
          this.$route.query.redirectFrom || {
            name: "E-Load Network Group Form", params: { id: item.networkId }
          }
        );
      },
      async onExport(){
        await this.getNetworkGroupList();
        if(this.loadNetworkGroupAllTotalRows ==0){
          Swal.fire("Failed!", this.exportNullPrompt, "warning");
          return;
        }
        let params = Object.assign(
          {
            module: 'eload_network_group',
            email: JSON.parse(localStorage.getItem('userData')).email,
            orderDesc: this.searchValue.orderDesc,
            search: this.searchValue.search,
            searchField: this.searchValue.searchField,
            sort: this.searchValue.sort,
            status: this.searchValue.status,
            service: this.searchValue.service
          });
        
        this.exportReport(params)
          .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
          .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
      }
    }
  }
    
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-4 col-sm-4">
                <div class="mt-2">
                  <h5 class="card-title">
                    <span class="fw-normal ms-2"
                      >{{loadNetworkGroupAllTotalRows}}</span
                    > Record(s)
                  </h5>
                </div>
              </div>
              <!-- end col -->

              <!-- Search and button -->
              <div class="col-md-8 col-sm-8"> 

                <div class="d-flex justify-content-end">
                    <div>
                      <!-- <b-button v-b-modal.bv-modal-create-network variant="primary" class="me-2" v-if="false"><i class="uil uil-plus me-1"></i> Add Network</b-button>

                      <router-link :to="{ name: 'E-Load Network Group Form', params: { id: 0 }}" class="tc-white me-2">
                        <button class="btn btn-primary" v-if="eloadNetworkGroupModule.access.create">
                            <i class="uil uil-plus me-1"></i> Add Network Group
                        </button>
                      </router-link> -->

                      <a class="btn btn-secondary" @click="onPageUpdate()"
                        ><feather
                          type="refresh-ccw"
                          size="16"
                          class="icon nav-icon"
                        ></feather
                        >&nbsp;&nbsp; Refresh</a
                      >
                    </div>
                </div>
              </div>

              <div class="col-md-12 col-sm-12">
                 <div class="row mt-4">
                    <div class="col-md-4 ta-right">
                      <b-form-group description="Search Keyword">
                        <form class="d-flex" @submit.prevent="onSearch()">
                          <b-form-group id="input-group-3" label-for="input-3">
                            <b-form-select
                              class="form-select rounded-0 rounded-start shadow-none"
                              style="width: fit-content"
                              id="input-3"
                              v-model="searchValue.searchField"
                              :options="searchListNetwork"
                            ></b-form-select>
                          </b-form-group>

                          <b-input-group>
                            <b-form-input
                              class="rounded-0"
                              v-model="searchValue.search"
                            ></b-form-input>
                          </b-input-group>
                        </form>
                      </b-form-group>
                    </div>
                    <div class="col-md-8">
                      <div class="d-flex align-items-start mt-2 mt-md-0 gap-2 mb-3 ta-right">
                        <b-form-group label-for="services" description="Filter by Service">
                          <b-form-select class="form-select rounded-0 rounded-start shadow-none"
                            v-model="searchValue.service"
                            :options="eloadServiceOptions"
                          ></b-form-select>
                        </b-form-group>
                        <b-form-group label-for="status" description="Filter by status">
                          <b-form-select class="form-select rounded-0 rounded-start shadow-none"
                            v-model="searchValue.status"
                            :options="statusList"
                          ></b-form-select>
                        </b-form-group>
                        <a class="btn btn-primary h-fit" @click="onPageUpdate('reset')">
                          <i class='bx bx-search bx-fw'></i>Search
                        </a>
                        <a
                          class="btn btn-primary"  @click="onExport"
                        >
                          <i class="uil uil-export me-1"></i>
                          Export
                        </a>
                      </div>
                    </div>

                </div>

              </div> <!-- end of list of filter-->
              <!-- end col -->
            </div>
            <!-- end row -->

            <!-- table responsive -->
            <div class="table-responsive">
              <div class="table align-middle table-nowrap">
                <b-table
                  :items="loadNetworkGroupListAll"
                  :fields="fieldsNetwork"
                  responsive="sm"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter-included-fields="filterOn"
                  @sort-changed="eloadNetworkSort"
                >

                  <template #cell(action)="data">
                    <div class="d-flex">
                      <b-button
                          id="show-btn"
                          class="btn btn-sm btn-danger"
                          @click="deleteEloadNetwork(data.item.networkId, data.item.name)"
                          ><i class="bx bx-trash bx-xs bx-fw"></i
                        ></b-button>
                    </div>
                  </template>
                  <template #cell(name)="data">
                    <b-link
                      class="fw-medium"
                      @click="editNetwork(data.item)"
                      >{{ data.item.name }}</b-link
                    >
                  </template>
                  <template #cell(image)="data">
                    <img
                    :src="data.item.networkImageSrc"
                    alt="Network Image"
                    @error="(e) => e.target.src = require('@/assets/images/img-placeholder.png')"
                    class="border-end img-fluid border-0 rounded-start img-cover"
                    style="width: 60px;"
                    />
                  </template>
                  <template #cell(status)="data">
                    <p
                      v-bind:class="
                        data.item.status=='a'
                          ? 'text-success m-0'
                          : 'text-danger m-0'
                      "
                    >
                      {{ data.item.status == 'i' ? "Inactive" : "Active" }}
                    </p>
                  </template>
                  <template #cell(service)="data">
                    {{ data.item.serviceName }}
                  </template>
                  <!-- <template #cell(apiEndPoint)="data">
                    <b-link
                      class="fw-medium"
                      >{{ data.item.api_endpoint }}</b-link
                    >
                  </template> -->
                  <template #cell(description)="data">
                    {{ data.item.description | truncator(20,'...')}}
                  </template>
                </b-table>
              </div>
            </div>
            <!-- end table responsive -->
            <div class="row g-0 text-center" v-if="loadNetworkGroupAllTotalRows == 0">
              <span>No data to display.</span>
            </div>
            <div class="row g-0 text-center text-sm-start" v-if="loadNetworkGroupAllTotalRows != 0 && loadNetworkGroupAllTotalRows > 10">
              <!-- end col -->
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <div class="form-group row pull-left">
                      <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                      <div class="col-sm-6">
                        <b-form-group label-for="display-record">
                          <b-form-select class="form-select shadow-none w-fit"
                            id="display-record"
                            v-model="perPage"
                            :options="pageOptions"
                            @change="onDisplayChange()"
                          ></b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                    <div
                      class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-end
                      "
                      v-if="loadNetworkGroupAllTotalRows > perPage"
                    >
                      <b-pagination
                        class="pagination-rounded"
                        v-model="currentPage"
                        @input="getNetworkGroupList()"
                        :total-rows="loadNetworkGroupAllTotalRows"
                        :per-page="perPage"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>

          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>   
  </div>
</template>